import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import promiseFinally from 'promise.prototype.finally';
import {AppModule} from "./app.module";

promiseFinally.shim();

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule);
}

if ((<any>window).cordova) {
  document.addEventListener('deviceready', bootstrap);
} else {
  bootstrap();
}



// WEBPACK FOOTER //
// ./src/app/main.ts